import React, { useRef } from 'react';
import { stylesheet } from 'typestyle';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label: string
  left?: boolean
  classNames?: string[]
  onClick?: (e: any) => any
}

function FormLabel({ left, label, children, classNames, onClick, ...props }: Props) {
  const divRef = useRef<HTMLDivElement>(null);

  function handleClick(e: React.MouseEvent<HTMLLabelElement, MouseEvent>) {
    if (onClick) {
      onClick(e);
    }
  }

  function renderLabel(lbl: string) {
    return (
      <label onClick={handleClick}>
        <span>{lbl}</span>
      </label>
    );
  }

  const _label = renderLabel(label);
  return (
    <div className={[sheet.labelContainer, ...(classNames || [])].join(' ')} {...props}>
      {left ? _label : null}
      <div ref={divRef}>
        {children}
      </div>
      {!left ? _label : null}
    </div>
  );
}

const sheet = stylesheet({
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    $nest: {
      label: {
        cursor: 'pointer',
        margin: '0 0 0 5px',
        fontSize: 12,
        $nest: {
          span: {
            verticalAlign: 'sub',
          },
        },
      },
    },
  },
});

export { FormLabel };
